export default class VectorTextGenerator {

	constructor(font) {
		this.font = font;

		if(font.flipY) {
			// some old vector font data is upside down, flip it
			for(let c in this.font) {
				let char = this.font[c];
				for(let p=0; p<char.length; p++) {
					let coords = char[p].split(' ');
					for(let v=0; v<coords.length; v++) {
						if(v%2 == 1) {
							coords[v] = font.flipHeight - parseFloat(coords[v]);
						}
					}
					this.font[c][p] = coords.join(' ');
				}
			}
		}
	}
	
	getTextPaths(message) {
		let chars = message.split('');
		let paths = [];
		for(let c of chars) {
			if(this.font[c] != undefined) {
				paths.push(...this.font[c]);
			} else {
				paths.push('X'); // unsupported character, just add a space
			}
		}
		return paths;
	}

}